import React from "react";
import { Routes, Route } from "react-router-dom";
import { MessageProvider } from "./context/MessageContext";
import "./App.css";

import Frontlayout from "./layout/frontlayout/Frontlayout";
import Innerlayout from "./layout/innerlayout/Innerlayout";

import Home from "./pages/Home";
import Playerprofile from "./pages/Playerprofile";
import Champions from "./pages/Champions";
import Courts from "./pages/Courts";
import Members from "./pages/Members";
import Playoffs from "./pages/Playoffs";
import Schedule from "./pages/Schedule";
// import Standings from "./pages/Standings";
import Standings from "./pages/standing/Standings";
import AboutUs from "./pages/AboutUs";
import Rules from "./pages/Rules";
import Contact from "./pages/Contact";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import Terms from "./pages/Terms";
import Users from "./pages/admin/Users";
import ManageRegistration from "./pages/admin/ManageSeason/ManageRegistration";
import ActiveUsers from "./pages/admin/ActiveUsers";
import MessageBoard from "./components/PlayerProfile/MessageBoard";
import AdminInbox from "./pages/admin/AdminInbox";
import Feedback from "./pages/feedback";
import SignUp from "./pages/SignUp";
import CreateSeason from "./components/Admin/ManageSeason/CreateSeason";
import EditManageSeason from "./components/Admin/ManageSeason/EditManageSeason";
import ManageCity from "./pages/admin/ManageCity/ManageCity";
import RegisterCity from "./pages/admin/ManageCity/RegisterCity";
import ManageCourses from "./pages/admin/ManageCity/ManageCourses";
import AdministrativeInbox from "./pages/admin/AdminInbox/AdministrativeInbox";
import UpdateCity from "./pages/admin/ManageCity/UpdateCity";
import RegistrationSuccess from "./components/SignUp/RegistrationSuccess";
import Payment from "./components/SignUp/Payment";
import ProcessPayment from "./components/SignUp/ProcessPayment";
import ViewSeason from "./pages/admin/ManageSeason/ViewSeason";
import ScheduleSeason from "./pages/admin/ManageSeason/ScheduleSeason";
import UnderPar from "./pages/admin/ManageSeason/UnderPar";
import Printcard from "./components/Schedule/Printcard";
import ViewResult from "./components/Schedule/ViewResult";
import PostResult from "./components/Schedule/PostResult";
import MemberSendMessage from "./components/Members/MemberSendMessage";
import InboxBoard from "./components/PlayerProfile/InboxBoard";
import Records from "./components/Members/Records";
import AdminMessageInbox from "./pages/admin/AdminInbox/AdminMessageInbox";
import PostScheduleSeason from "./pages/admin/ManageSeason/PostScheduleSeason";
import ClearSeasonList from "./pages/admin/ClearSeasonList";
import Forgot from "./pages/Forget/Forgot";
import ResetPassword from "./pages/Forget/ResetPassword";

function App() {
  return (
    <MessageProvider>
      <Routes>
        <Route path="/" element={<Frontlayout />} />
        <Route path="/carter" element={<Innerlayout />}>
          <Route index element={<Home />} />
          <Route path="home" element={<Home />} />
          <Route path="signup" element={<SignUp />} />
          <Route path="profile" element={<Playerprofile />} />
          <Route path="editprofile" element={<SignUp />} />
          <Route path="champions" element={<Champions />} />
          <Route path="courts" element={<Courts />} />
          <Route path="members" element={<Members />} />
          <Route path="sendMessage" element={<MemberSendMessage />} />
          <Route path="members/record" element={<Records />} />
          <Route path="playoffs" element={<Playoffs />} />
          <Route path="schedule" element={<Schedule />} />
          <Route path="schedule/printcard" element={<Printcard />} />
          <Route path="schedule/viewresult" element={<ViewResult />} />
          <Route path="schedule/postresult" element={<PostResult />} />
          <Route path="standing" element={<Standings />} />
          <Route path="aboutus" element={<AboutUs />} />
          <Route path="contactus" element={<Contact />} />
          <Route path="feedback" element={<Feedback />} />
          <Route path="privacypolicy" element={<PrivacyPolicy />} />
          <Route path="terms" element={<Terms />} />
          <Route path="msgboard" element={<MessageBoard />} />
          <Route path="inboxboard" element={<InboxBoard />} />
          <Route path="rule" element={<Rules />} />
          <Route path="signupregistrationsuccess" element={<RegistrationSuccess />} />
          <Route path="payment" element={<Payment />} />
         
          
          

          {/* admin routes */}
          <Route path="users" element={<Users />} />
          <Route path="manageRegistration" element={<ManageRegistration />} />
          <Route path="clearSeasonList" element={<ClearSeasonList />} />
          <Route path="viewSeason" element={<ViewSeason />} />
          <Route path="scheduleSeason" element={<ScheduleSeason />} />
          <Route path="postscheduleSeason" element={<PostScheduleSeason />} />
          <Route path="underParSeason" element={<UnderPar />} />
          <Route path="citymanage" element={<ManageCity />} />
          <Route path="registercity" element={<RegisterCity />} />
          <Route path="updatecity" element={<UpdateCity />} />
          <Route path="manageCourses" element={<ManageCourses />} />
          <Route path="administrateInbox" element={<AdministrativeInbox />} />
          <Route path="activeUsers" element={<ActiveUsers />} />
          <Route path="admininbox" element={<AdminInbox />} />
          <Route path="registrationForm" element={<CreateSeason />} />
          <Route path="editregistrationForm" element={<EditManageSeason />} />
          <Route path="administrateInbox/AdminMessageInbox" element={<AdminMessageInbox />} />
        </Route>
        <Route path="/forget" element={<Forgot />} />
        <Route path="/reset-password" element={<ResetPassword />} />
      </Routes>
    </MessageProvider>
  );
}

export default App;

